import React from 'react';
import { Card, CardBody, Button, Input, Col, Container, Row } from "reactstrap";
import Doll from '../../assets/images/doll-1.png';
import Add_Token_Modal from '../../Components/Common/CustomModal/Add_Token_Modal';
import moment from 'moment';
import { useLocation } from 'react-router-dom';

const Token_Balane = ({TokenAllowed , expires , TokenRemaining , Next_Bill_Date}) => {
    const { pathname } = useLocation()

  
  return (
    <>
        <Card className='no_border'>
            <CardBody>
                <div className="d-flex align-items-center">
                    <div className="flex-grow-1">
                        <h5 className="card-title mb-1">Token balance</h5>
                    </div>
                    <div className="float-end flex-shrink-0">
                        <img src={Doll} alt="" className="avatar-sm rounded-circle" />
                    </div>                                        
                </div>
            </CardBody>
            <div className="card-footer pbt_0 add_token_wrap">
                <div className='tokenallowed'>
                <p style={{marginBottom:"0px"}}><b>{TokenRemaining?.toLocaleString()}</b></p>
                <p className='text-muted'>Expires on <span>{moment(expires).format('yyyy-MM-DD')}</span></p>
                </div>
                <div>{!pathname.includes('Group_Dashboard') &&  <Add_Token_Modal Next_Bill_Date={Next_Bill_Date} />} </div>
            </div>
        </Card>
    </>
  )
}

export default Token_Balane
